export default {"src":"/_next/static/media/play-arrow.19ed1603.svg","height":192,"width":192};